module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/文本切图-游戏攻略专区.62279.png";